import React from "react";

const ScoreCircle = ({ score, size = 52 }) => {
  if (score === null || score === undefined || score === "--") {
    return <span className="no-score-text">--</span>;
  }
  const num = Math.round(typeof score === "number" ? score : parseFloat(score));
  const radius = (size - 10) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (Math.min(num, 100) / 100) * circumference;
  const color = num >= 80 ? "#4CC948" : num >= 60 ? "#2F80ED" : "#FF6835";
  return (
    <div className="score-circle-wrap" style={{ width: size, height: size }}>
      <svg width={size} height={size} style={{ position: "absolute", top: 0, left: 0 }}>
        <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="#E4E9F0" strokeWidth={5} />
        <circle
          cx={size / 2} cy={size / 2} r={radius} fill="none" stroke={color} strokeWidth={5}
          strokeDasharray={circumference} strokeDashoffset={offset} strokeLinecap="round"
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
      </svg>
      <span className="score-circle-num" style={{ color }}>{num}</span>
    </div>
  );
};

export default ScoreCircle;
